import { Card, CardActions, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { ErrorRecord, Product } from "../../types";
import { Building2 } from "lucide-react";

export type Props = {
    changedProduct: Product;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error: boolean;
    errors: ErrorRecord<Product>;
};

export const EditFactory = (props: Props) => {
    return (
        <Container>
            <Card
                variant="outlined"
                sx={{
                    borderRadius: "30px",
                    width: "90%",
                    overflowY: "auto",
                    maxHeight: "80vh",
                    padding: "5px",
                    marginBottom: "30px",
                }}
            >
                {" "}
                <StyledCardActions>
                    <IconActionsWrapper>
                        <Building2 />{" "}
                        <Typography
                            fontFamily={"'Poppins', sans-serif"}
                            fontSize={18}
                            color="#8c8c8c"
                            fontWeight={600}
                        >
                            Location
                        </Typography>
                    </IconActionsWrapper>
                </StyledCardActions>
                <Form autoComplete="off">
                    <TextField
                        label="Town"
                        name="town"
                        variant="outlined"
                        value={props.changedProduct.town}
                        onChange={e => props.handleChange(e)}
                        sx={{ ...sx, marginTop: "20px" }}
                    />
                    <TextField
                        label="Building"
                        name="warehousePlacement"
                        variant="outlined"
                        value={props.changedProduct.warehousePlacement}
                        onChange={e => props.handleChange(e)}
                        sx={sx}
                    />
                    <TextField
                        label="Room"
                        name="roomPlacement"
                        variant="outlined"
                        value={props.changedProduct.roomPlacement}
                        onChange={e => props.handleChange(e)}
                        sx={sx}
                    />
                    <TextField
                        label="Quantity"
                        name="quantity"
                        variant="outlined"
                        type="number"
                        required
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={props.changedProduct.quantity}
                        onChange={e => props.handleChange(e)}
                        error={props.errors.quantity ? true : false}
                        helperText={props.errors.quantity}
                        sx={{ ...sx, marginBottom: "10px" }}
                    />
                </Form>
            </Card>
        </Container>
    );
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 95%;
    margin: 0 auto;
    gap: 20px;
`;
const IconActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    gap: 5px;
`;
const StyledCardActions = styled(CardActions)`
    display: flex;
    width: 100%;
    font-size: 3rem;
    border-bottom: 1px solid #ebebeb;
    //background-color: #ebebeb;
    align-items: center; /* Centrerar vertikalt i flex-container */
`;
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

const sx = {
    "& .MuiInputBase-root": {
        fontFamily: "'Yllw Sans a1 241219', sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        color: "black",
        backgroundColor: "white",
    },
    "& .MuiInputLabel-root": {
        fontFamily: "'Yllw Sans a1 241219', sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        color: "rgba(0, 0, 0, 0.50)",
    },
    "& .MuiInputBase-input::placeholder": {
        fontFamily: "'Yllw Sans a1 241219', sans-serif",
        fontSize: "16px",
        fontWeight: "400",
        color: "rgba(0, 0, 0, 0.50)",
    },
};
